import React, { Component } from 'react';
import { withGoogleMap, GoogleMap, withScriptjs, InfoWindow, Marker } from "react-google-maps";
import Geocode from "react-geocode";
let GoogleMapsAPI = '';
let GoogleGeocodeAPI = '';
let GoogleMapsURL = '';
let GoogleMapsLanguage = '';

Geocode.enableDebug();

class Map extends Component {



    constructor(props) {
        // console.log(process.env.NODE_ENV);
        GoogleMapsAPI = process.env.REACT_APP_GOOGLE_MAPS_KEY || '';
        GoogleGeocodeAPI = process.env.REACT_APP_GOOGLE_GEOCODE_KEY || '';
        Geocode.setApiKey(GoogleMapsAPI);

        super(props);
        this.state = {
            setUbicacionVerificada: this.props.setUbicacionVerificada,
            latitude: this.props.center.setLatitude,
            longitude: this.props.center.setLongitude,
            mapPosition: {
                lat: this.props.center.lat,
                lng: this.props.center.lng
            },
            markerPosition: {
                lat: this.props.center.lat,
                lng: this.props.center.lng
            }
        }

        GoogleMapsURL = process.env.REACT_APP_API_URL + 'api/app/solicitud-servicio/get-geocode-data?subscriptionKey=' + GoogleGeocodeAPI + '&latitude=' + this.state.mapPosition.lat + '&longitude=' + this.state.mapPosition.lng + '&username=' + localStorage.getItem("usuario_nombre");
        var idioma = localStorage.getItem("idioma");
        if(idioma === 'en-US'){
            GoogleMapsLanguage = "en";
        }
        else{
            GoogleMapsLanguage = "es";
        }

    }
    /**
     * Get the current address from the default map position and set those values in the state
     */
    componentDidMount() {


        /* fetch(GoogleMapsURL).then(response => response.json())
             .then(data => {
                 if (data.results.length) {
                     const address = data.results[0].formatted_address,
                         addressArray = data.results[0].address_components,
                         city = this.getCity(addressArray),
                         area = this.getArea(addressArray),
                         state = this.getState(addressArray);
 
                     this.setState({
                         calle: (address) ? address : '',
                         area: (area) ? area : '',
                         city: (city) ? city : '',
                         state: (state) ? state : '',
                     });
                 }
 
 
             }).catch(err=>{
 
             });*/
    };
    /**
     * Component should only update ( meaning re-render ), when the user selects the address, or drags the pin
     *
     * @param nextProps
     * @param nextState
     * @return {boolean}
     */
    shouldComponentUpdate(nextProps, nextState) {





        if (this.state.markerPosition.lat !== nextState.latitude && nextState.latitude !== undefined) {
            this.setState({
                markerPosition: {
                    lat: nextState.latitude,
                    lng: nextState.longitude
                },


            });
         
                        return true;
                    }
                    else {

                        return false;
                    }

                }
    /**
     * Get the city and set the city input value to the one selected
     *
     * @param addressArray
     * @return {string}
     */
    getCity = (addressArray) => {
                        let city = '';
                        if (addressArray != undefined) {
                            for (let i = 0; i < addressArray.length; i++) {
                                if (addressArray[i].types[0] && 'locality' === addressArray[i].types[0]) {
                                    city = addressArray[i].long_name;
                                    return city;
                                }
                            }
                        }

                    };
            /**
             * Get the area and set the area input value to the one selected
             *
             * @param addressArray
             * @return {string}
             */
            getArea = (addressArray) => {
                let area = '';
                if (addressArray != undefined) {
                    for (let i = 0; i < addressArray.length; i++) {
                        if (addressArray[i].types[0]) {
                            for (let j = 0; j < addressArray[i].types.length; j++) {
                                if ('sublocality_level_1' === addressArray[i].types[j] || 'locality' === addressArray[i].types[j]) {
                                    area = addressArray[i].long_name;
                                    return area;
                                }
                            }
                        }
                    }
                }

            };

            getStreetNumber = (addressArray) => {
                let area = '';
                if (addressArray != undefined) {
                    for (let i = 0; i < addressArray.length; i++) {
                        if (addressArray[i].types[0]) {
                            for (let j = 0; j < addressArray[i].types.length; j++) {
                                if ('street_number' === addressArray[i].types[j]) {
                                    area = addressArray[i].long_name;
                                    return area;
                                }
                            }
                        }
                    }
                }

            };

            getStreet = (addressArray) => {
                let area = '';
                if (addressArray != undefined) {
                    for (let i = 0; i < addressArray.length; i++) {
                        if (addressArray[i].types[0]) {
                            for (let j = 0; j < addressArray[i].types.length; j++) {
                                if ('route' === addressArray[i].types[j]) {
                                    area = addressArray[i].long_name;
                                    return area;
                                }
                            }
                        }
                    }
                }
            };


            getZip = (addressArray) => {
                let area = '';
                if (addressArray != undefined) {
                    for (let i = 0; i < addressArray.length; i++) {
                        if (addressArray[i].types[0]) {
                            for (let j = 0; j < addressArray[i].types.length; j++) {
                                if ('postal_code' === addressArray[i].types[j]) {
                                    area = addressArray[i].long_name;
                                    return area;
                                }
                            }
                        }
                    }
                }

            };
            /**
             * Get the address and set the address input value to the one selected
             *
             * @param addressArray
             * @return {string}
             */
            getState = (addressArray) => {
                let state = '';
                if (addressArray != undefined) {

                    for (let i = 0; i < addressArray.length; i++) {
                        for (let i = 0; i < addressArray.length; i++) {
                            if (addressArray[i].types[0] && 'administrative_area_level_1' === addressArray[i].types[0]) {
                                state = addressArray[i].long_name;
                                return state;
                            }
                        }
                    }
                }
            };
            /**
             * And function for city,state and address input
             * @param event
             */
            onChange = (event) => {

                this.setState({ [event.target.name]: event.target.value });
            };
            /**
             * This Event triggers when the marker window is closed
             *
             * @param event
             */
            onInfoWindowClose = (event) => {

            };
            
            handleZoomChanged = () => {
                this.props.onZoomChanged(this.mapObject.getZoom());
              }

            /**
             * When the marker is dragged you get the lat and long using the functions available from event object.
             * Use geocode to get the address, city, area and state from the lat and lng positions.
             * And then set those values in the state.
             *
             * @param event
             */
            onMarkerDragEnd = (event) => {
                let newLat = event.latLng.lat(),
                    newLng = event.latLng.lng();


                this.setState({
                    markerPosition: {
                        lat: newLat,
                        lng: newLng
                    },
                    mapPosition: {
                        lat: newLat,
                        lng: newLng
                    },
                    latitude: newLat,
                    longitude: newLng
                });

                this.state.setUbicacionVerificada({latitud:newLat, longitud: newLng});
                /*  fetch(GoogleMapsURL).then(response => response.json())
                      .then(data => {
          
                          if( data.results.length){
                              const address = data.results[0].formatted_address,
                              addressArray = data.results[0].address_components,
                              city = this.getCity(addressArray),
                              area = this.getArea(addressArray),
                              state = this.getState(addressArray);
                         
                          this.state.setDireccion(address);
                          this.state.setCalle(this.getStreet(addressArray));
                          this.state.setCalleNumero(this.getStreetNumber(addressArray));
                          this.state.setEstado(this.state.state, this.state.city, this.state.area);
                          this.state.setZip(this.getZip(addressArray));
                          }
                         
                          //   this.state.setZoom(5);
                      }
                      );*/



            };

            /**
             * When the user types an address in the search box
             * @param place
             */
            onPlaceSelected = (place) => {


                const address = place.formatted_address,
                    latValue = place.geometry.location.lat(),
                    lngValue = place.geometry.location.lng();
                // Set these values in the state.
                this.setState({
                    markerPosition: {
                        lat: latValue,
                        lng: lngValue
                    },
                    mapPosition: {
                        lat: latValue,
                        lng: lngValue
                    },
                })
            };





            render() {
                const AsyncMap = withScriptjs(
                    withGoogleMap(
                        props => (
                            <GoogleMap google={this.props.google}
                                zoom={this.props.zoom} defaultOptions={true}
                                onZoomChanged={this.handleZoomChanged}
                                ref={map => (this.mapObject = map)}
                                defaultCenter={{ lat: this.state.mapPosition.lat, lng: this.state.mapPosition.lng }}

                            >
                                {/* InfoWindow on top of marker */}
                                {/* <InfoWindow
                            onClose={this.onInfoWindowClose}
                            position={{ lat: (this.state.markerPosition.lat + 0.0018), lng: this.state.markerPosition.lng }}
                        >
                             <div>
                                <span style={{ padding: 0, margin: 0 }}>{this.state.calle}</span>
                            </div> 
                        </InfoWindow>    */}
                                {/*Marker*/}
                                <Marker google={this.props.google}

                                    draggable={true}
                                    onDragEnd={this.onMarkerDragEnd}
                                    position={{ lat: this.state.markerPosition.lat, lng: this.state.markerPosition.lng }}
                                />
                                {/*<Marker/> */}

                            </GoogleMap>
                        )
                    )
                );
                let map;
                if (this.props.center.lat !== undefined) {
                    map = <div>
                        <AsyncMap
                            googleMapURL={`https://maps.googleapis.com/maps/api/js?key=${GoogleMapsAPI}&libraries=places&language=${GoogleMapsLanguage}`}
                            loadingElement={
                                <div style={{ height: `100%` }} />
                            }
                            containerElement={
                                <div style={{ height: this.props.height }} />
                            }
                            mapElement={
                                <div style={{ height: `100%` }} />
                            }
                        />
                    </div>
                } else {
                    map = <div style={{ height: this.props.height }} />
                }
                return (map)
            }
        }
        export default Map
